import {
  Backdrop,
  Button,
  makeStyles,
  TablePagination,
  useTheme,
} from "@material-ui/core";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import useResizer from "../../services/useResizer";
import styled from "styled-components";
import { useParams, Link } from "react-router-dom";
import { REACT_APP_PROD_URL, PRICES_URL } from "../../services/configs";
import { icons } from "../../assets/icons/coinIcons.js";
import { CoinContext } from "../../contexts/CoinContext";
import * as Sentry from "@sentry/react";
import loaderGif from "../../assets/img/loader.gif";
import useSWR from "swr";
import fetcher from "../../api/swr_fetcher";
import { flow } from "lodash";
import WalletCard from "../../components/WalletCard";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { debounce } from "lodash";

import INRWalletCard from "../../components/INRWalletCard";
import Hidden from "@material-ui/core/Hidden";
import { AnimatePresence, motion } from "framer-motion";
import CryptoWallet from "../CryptoWallet";
import INRWallet from "../INRWallet";

export default function Wallet(props) {
  const { type } = useParams();

  const classes = useStyles();
  const isMobile = useResizer();
  let history = useHistory();
  const darkMode = useSelector((state) => state.trading.DARK_MODE);
  const [filterType, setFilterType] = useState(type);

  useEffect(() => {
    setFilterType(type);
  }, [type]);

  useEffect(() => {
    if (!["crypto", "inr"].includes(type)) {
      // history.replace("/trade/BTC");
    }
  }, []);

  const getScreenBasedOnDevice = (isMobile, filterType) => {
    if (isMobile) {
      return (
        <div>
          <div className={classes.root}>
            <div className="flex justify-between items-center mb-5">
              <h1 className="">
                {filterType.charAt(0).toUpperCase() + filterType.slice(1)}{" "}
                Wallet
              </h1>
            </div>
            <div className="mb-5">
              {" "}
              {/* <ToggleSwitch
                values={[
                  { id: "crypto", value: "Crypto" },
                  { id: "inr", value: "INR" },
                ]}
                selected={type}
                className="mr-5"
                darkMode={darkMode}
                onChange={() => {}}
              /> */}
            </div>

            <div>{getMobileScreen(filterType)}</div>
          </div>
        </div>
      );
    } else {
      return getDesktopScreen(filterType);
    }
  };

  function getDesktopScreen(filterType) {
    switch (filterType) {
      case "crypto":
        return <CryptoWallet></CryptoWallet>;
      case "inr":
        return <INRWallet></INRWallet>;
      default:
        return <INRWallet></INRWallet>;
    }
  }
  function getMobileScreen(filterType) {
    switch (filterType) {
      case "crypto":
        return <CryptoWalletMobile></CryptoWalletMobile>;
      case "inr":
        return <INRWalletMobile></INRWalletMobile>;
      default:
        return <INRWalletMobile></INRWalletMobile>;
    }
  }
  return <div>{getScreenBasedOnDevice(isMobile, filterType)}</div>;
}

function ToggleSwitch(props) {
  const [selected, setSelected] = useState(props.selected);

  useEffect(() => {
    setSelected(props.selected);
  }, [props.selected]);

  const handleChange = (val) => {
    setSelected(val);
    props.onChange(val);
  };

  const selectionStyle = () => {
    return {
      left: `${
        (props.values
          .map(function (e) {
            return e.id;
          })
          .indexOf(selected) /
          2) *
        100
      }%`,
    };
  };
  return (
    <Switch {...props}>
      {props.values.map((val) => {
        return (
          <Link to={"/wallet/" + val.id}>
            <span>
              <ConcealedRadio value={val.id} selected={selected} />
              <ClickableLabel
                title={val.value}
                id={val.id}
                onChange={handleChange}
              />
            </span>
          </Link>
        );
      })}
      <SwitchSelection style={selectionStyle()} darkMode={props.darkMode} />
    </Switch>
  );
}

const ClickableLabel = ({ title, onChange, id }) => (
  <SwitchLabel onClick={() => onChange(id)} className={id}>
    {title}
  </SwitchLabel>
);

const ConcealedRadio = ({ value, selected }) => {
  return <SwitchRadio type="radio" name="switch" checked={selected == value} />;
};

const Switch = styled.div`
  position: relative;
  width: 100%;
  height: 50px;
  color: ${(props) => (props.darkMode ? "#fff" : "#000")};
  background-color: ${(props) => (props.darkMode ? "#0F1421" : "#F1F1F1")};
  border-radius: 3px;
`;

const SwitchRadio = styled.input`
  display: none;
`;

const SwitchSelection = styled.span`
  display: block;
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 0px;
  width: 50%;
  height: 100%;
  background-color: ${(props) => (props.darkMode ? "#141C2E" : "#FDFDFD")};
  border-radius: 3px;
  transition: left 0.25s ease-out;
`;

const SwitchLabel = styled.label`
  position: relative;
  z-index: 2;
  float: left;
  width: 50%;
  // line-height: 26px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  ${SwitchRadio}:checked + & {
    transition: all 0.15s ease-out;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.08));
    border-bottom: 3px solid #3ac4ab;
  }
`;

function CryptoWalletMobile(props) {
  const classes = useStyles();
  const [coinsConfig, setCoinsConfig] = useState(null);
  const [allBalances, setAllBalances] = useState(null);
  const [iconList, setIconList] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [dynamicList, setDynamicList] = useState(null);
  const [initialDynamicList, setInitialDynamicList] = useState([]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState({ title: "", content: "" });
  const { bannedTimeout } = useContext(CoinContext);
  const darkMode = useSelector((state) => state.trading.DARK_MODE);
  const coinIcons = useSelector((state) => state.trading.COIN_ICONS);
  const handleClickOpen = (message) => {
    setMessage(message);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const fetchCoinConfig = (e) => {
    return fetcher(`/v1/coinConfig`);
  };
  async function fetchConfig() {
    const icons = await fetchCoinConfig();
    console.log(icons, "icons");
    setIconList(icons);
  }
  useEffect(() => {
    fetchConfig();
  }, []);
  const { data: balancesData, error: balancesError } = useSWR(
    `/v1/balances`,
    fetcher,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );
  const { data: coinConfigData, error: coinError } = useSWR(
    `/v1/coinConfig`,
    fetcher,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );
  useEffect(() => {
    if (balancesData) generateBalancesData(balancesData);
    if (coinConfigData) generateCoinConfigData(coinConfigData);
  }, [balancesData, coinConfigData]);

  useEffect(() => {
    if (balancesError?.status === 401) {
      bannedTimeout("timeout");
    } else if (balancesError?.status === 403) {
      bannedTimeout("banned");
    }
  }, [balancesError]);

  async function generateBalancesData(data) {
    var balanceDict = {};
    data.map((item) => {
      balanceDict[item.coinId] = item;
    });

    let temp = [];
    console.log(iconList, "iconlist");
    let icons = iconList || [];
    Object.keys(balanceDict).map((ele, idx) => {
      let icon = icons.find((icon) => icon.coinId == ele);
      balanceDict[ele]["icon"] = icon;
      balanceDict[ele]["id"] = idx;
      if (ele !== "INR") temp.push(balanceDict[ele]);
    });

    temp.sort(
      (a, b) => Number(b.availableBalance) - Number(a.availableBalance)
    );

    setAllBalances(balanceDict);
    setInitialDynamicList(temp);
    setDynamicList(temp);
  }

  function generateCoinConfigData(data) {
    var configDict = {};
    data.map((item) => {
      configDict[item.coinId] = item;
    });
    setCoinsConfig(configDict);
  }

  const debounceLoadData = useCallback(debounce(handleSearch, 1000), []);

  function handleSearch(value, initialDynamicList) {
    const val = value.replace(/[^a-zA-Z]/, "");

    const searchedList =
      initialDynamicList &&
      initialDynamicList.filter(function (item) {
        console.log(item, "item");
        if (item.icon)
          return (
            item.icon.coinId.toLowerCase().search(val.toLowerCase()) !== -1 ||
            item.icon.coinName.toLowerCase().search(val.toLowerCase()) !== -1
          );
      });

    setDynamicList(searchedList);
  }
  console.log(iconList, "listdyna");
  return (
    <div>
      <Backdrop className={classes.backdrop} open={!balancesData}>
        <img src={loaderGif} alt="loading..." />
      </Backdrop>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{message.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message.content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            variant="contained"
            style={{
              color: "white",
              fontWeight: "bold",
              marginRight: "17px",
              marginBottom: "12px",
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <div className="mb-5">
        <input
          type="text"
          className="bg-gray-300 dark:bg-gray-900 shadow-none border-none  p-3 w-full dark:text-white rounded-md py-4"
          placeholder="Search Coins"
          value={searchText}
          onChange={(event) => {
            setSearchText(event.target.value);
            debounceLoadData(event.target.value, initialDynamicList);
          }}
        ></input>
      </div>
      {coinConfigData &&
        dynamicList?.map((row, idx) => (
          <div
            style={{
              borderBottom: !darkMode ? "1px solid #999" : "1px solid #000",
            }}
          >
            <WalletCard
              coinIcons={coinIcons[row.coinId]}
              key={row.id}
              coin={row}
              config={coinsConfig?.[row.coinId] || false}
              rounded={
                idx == 0
                  ? "rounded-tl-lg rounded-tr-lg"
                  : idx == dynamicList.length - 1
                  ? "rounded-bl-lg rounded-br-lg"
                  : false
              }
              handleClickOpen={handleClickOpen}
            ></WalletCard>
          </div>
        ))}
    </div>
  );
}
function INRWalletMobile() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();
  const darkMode = useSelector((state) => state.trading.DARK_MODE);
  const token = useSelector((state) => state.trading.TOKEN);

  const [inrBalance, setInrBalance] = useState(null);
  const [inrTrans, setInrTrans] = useState(null);
  const [isBank, setIsBank] = useState(null);
  const [open, setOpen] = useState(false);
  // const [y, setY] = useState(0);

  const [kycDone, setKycDone] = useState(false);
  // const [showCTA, setShowCTA] = useState(true);

  const { bannedTimeout, handleClickAlert } = useContext(CoinContext);

  // for pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getInrBalance();
  }, [token]);
  // const handleNavigation = useCallback(
  //   (e) => {
  //     const window = e.currentTarget;

  //     if (
  //       !(
  //         window.innerHeight + window.scrollY >=
  //         document.body.offsetHeight - 800
  //       )
  //     ) {
  //       setShowCTA(true);
  //     } else {
  //       setShowCTA(false);
  //     }
  //   },
  //   [y]
  // );

  // useEffect(() => {
  //   setY(window.scrollY);
  //   window.addEventListener("scroll", handleNavigation);

  //   return () => {
  //     window.removeEventListener("scroll", handleNavigation);
  //   };
  // }, [handleNavigation]);
  // useEffect(() => {
  //   setY(window.scrollY);
  // }, []);
  function getInrBalance() {
    if (token) {
      var bearer = "Bearer " + token;
      fetcher(`/v1/balances/INR`)
        .then((data) => {
          // console.log(data);
          if (data[0]) {
            setInrBalance(data[0].availableBalance);
          }
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
      // console.log("Getting INR balance");
    }
  }

  useEffect(() => {
    loadInrTrans();
  }, [page, rowsPerPage]);

  function loadInrTrans() {
    if (token) {
      fetcher(
        `/v1/transfers/inr?sortBy=createdAt&direction=DESC&page=${
          page + 1
        }&pageSize=${rowsPerPage}`
      )
        .then((data) => {
          // console.log(data);
          if (!data.status) {
            setInrTrans(data);
          }
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
      // console.log("Getting INR transactions");
    }
  }

  function checkBank(props) {
    fetcher(`/v1/um/getKycDetails`)
      .then((data) => {
        if (data.verified === true || data.status === "approved") {
          setKycDone(true);
          // console.log("fetching bank account");
          fetcher(`/v1/um/bankAccount`)
            .then((data) => {
              // console.log("Bank: ", data);
              if (data.status === "verified" || data.status === "1") {
                history.push(`/inr/${props}`);
              } else {
                handleClickOpen();
              }
            })
            .catch((err) => {
              console.error(err);
              // console.error(err);
              handleClickOpen();
            });
        } else {
          handleClickOpen();
        }
      })
      .catch((err) => {
        console.error(err);
        // console.error(err);
      });
  }

  function cancelRequest(cancelId) {
    if (cancelId) {
      var bearer = "Bearer " + token;
      fetcher(`/v1/transfers/inr/cancel/${cancelId}`, { method: "POST" })
        .then((res) => {
          handleClickAlert("success", "Request cancelled successfully.");

          getInrBalance();
          loadInrTrans();
          // console.log(res);
        })
        .catch((err) => {
          handleClickAlert("error", "Failed to cancel request");

          console.error(err);
          // console.error(err);
        });
    } else {
      handleClickAlert("error", "Failed to cancel request");
    }
  }
  return (
    <div>
      <div className="flex justify-between mb-4">
        <div>
          <p className="text-gray-800 dark:text-gray-400 text-xs">
            Wallet Balance
          </p>
          <h2>₹ {inrBalance ? Number(inrBalance) : "0"}</h2>
        </div>{" "}
        {/* <div>
          <p className="text-gray-500">Wallet Balance</p>
        </div> */}
      </div>
      <div className="dark:bg-[#141828] bg-gray-200 p-4 rounded-md">
        <h3 className="mb-3 font-light ">Transactions</h3>
        {inrTrans?.content?.length ? (
          inrTrans?.content.map((row) => (
            <>
              <INRWalletCard transaction={row}></INRWalletCard>
            </>
          ))
        ) : (
          <p className="text-xs font-medium text-center mt-6 my-4">
            Transactions not found
          </p>
        )}
        <div className="flex justify-center">
          <TablePagination
            classes={{ root: classes.rootPagination }}
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={inrTrans ? inrTrans.totalElements : 10}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            labelRowsPerPage="Rows"
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </div>
      </div>{" "}
      <AnimatePresence>
        <div>
          <motion.div
            animate={{ y: 0, opacity: 1 }}
            initial={{ y: 100, opacity: 0 }}
            transition={{
              type: "tween",
              stiffness: 100,
              duration: 1,
            }}
            exit={{ y: 100, opacity: 0 }}
            className={` ${classes.buttons} flex items-center justify-center`}
          >
            {" "}
            <span className="mr-2 w-full">
              <Link to="/wallet/inr/withdraw">
                <Button
                  variant="outlined"
                  disableElevation
                  className="bg-[#F7F7F7] dark:bg-[#090D1C]"
                  style={{
                    textTransform: "none",
                    fontWeight: "bold",
                    width: "100%",
                    height: "40px",
                    color: darkMode ? "#999" : "#555",
                  }}
                >
                  Withdraw
                </Button>{" "}
              </Link>
            </span>
            <div className="w-full">
              <Link to="/wallet/inr/deposit">
                <Button
                  variant="contained"
                  disableElevation
                  color="primary"
                  className="text-white "
                  style={{
                    textTransform: "none",
                    fontWeight: "bold",
                    width: "100%",
                    height: "40px",
                  }}
                >
                  Deposit
                </Button>
              </Link>
            </div>
          </motion.div>
        </div>
      </AnimatePresence>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ marginTop: "15px" }}>
          {kycDone
            ? "Add Bank Account to Deposit/Withdraw INR"
            : "Complete your KYC to Deposit/Withdraw INR"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {kycDone
              ? `You will need to verify your bank accouny details to deposit and
              withdraw INR. Click on the button below to verify the bank account
              you will use for Deposit/Withdraw of INR.`
              : `You will need to verify KYC details to deposit and
              withdraw INR. Click on the button below to verify KYC details.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Hidden smDown>
            <Button
              onClick={() => {
                // updateDrawer(Date.now());
                if (kycDone) {
                  history.push(`/accsettings?tab=1`);
                } else {
                  history.push(`/accsettings`);
                }
              }}
              color="primary"
              variant="contained"
              style={{ color: "white", fontWeight: "bold", margin: "20px" }}
            >
              {kycDone ? "Add Bank Account" : "Complete KYC verification"}
            </Button>
          </Hidden>
          <Hidden mdUp>
            <Button
              onClick={() => {
                // updateDrawer(Date.now());
                if (kycDone) {
                  history.push(`/bank`);
                } else {
                  history.push(`/onboarding`);
                }
              }}
              color="primary"
              variant="contained"
              style={{ color: "white", fontWeight: "bold", margin: "20px" }}
            >
              {kycDone ? "Add Bank Account" : "Complete KYC verification"}
            </Button>
          </Hidden>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: "80px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  rootPagination: {
    overflow: "hidden",
    left: "0px",
    marginBottom: "0px",
    display: "flex",
  },
  buttons: {
    position: "fixed",
    width: "calc(100vw - 50px)",
    bottom: "80px",
    zIndex: "99",
  },
}));
